import { createSelector } from 'reselect';

export const Types = {
  GET_REQUEST: 'campaigns/GET_REQUEST',
  GET_SUCCESS: 'campaigns/GET_SUCCESS',
  GET_FAILURE: 'campaigns/GET_FAILURE',

  GET_LIST_REQUEST: 'campaigns/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'campaigns/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'campaigns/GET_LIST_FAILURE',

  CREATE_REQUEST: 'campaigns/CREATE_REQUEST',
  CREATE_SUCCESS: 'campaigns/CREATE_SUCCESS',
  CREATE_FAILURE: 'campaigns/CREATE_FAILURE',

  UPDATE_REQUEST: 'campaigns/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'campaigns/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'campaigns/UPDATE_FAILURE',

  DELETE_REQUEST: 'campaigns/DELETE_REQUEST',
  DELETE_SUCCESS: 'campaigns/DELETE_SUCCESS',
  DELETE_FAILURE: 'campaigns/DELETE_FAILURE',

  GET_CHANNELS_REQUEST: 'campaigns/GET_CHANNELS_REQUEST',
  GET_CHANNELS_SUCCESS: 'campaigns/GET_CHANNELS_SUCCESS',
  GET_CHANNELS_FAILURE: 'campaigns/GET_CHANNELS_FAILURE',

  GET_STORES_REQUEST: 'campaigns/GET_STORES_REQUEST',
  GET_STORES_SUCCESS: 'campaigns/GET_STORES_SUCCESS',
  GET_STORES_FAILURE: 'campaigns/GET_STORES_FAILURE',

  GET_PRODUCT_TYPES_REQUEST: 'campaigns/GET_PRODUCT_TYPES_REQUEST',
  GET_PRODUCT_TYPES_SUCCESS: 'campaigns/GET_PRODUCT_TYPES_SUCCESS',
  GET_PRODUCT_TYPES_FAILURE: 'campaigns/GET_PRODUCT_TYPES_FAILURE',

  GET_SECTIONS_REQUEST: 'campaigns/GET_SECTIONS_REQUEST',
  GET_SECTIONS_SUCCESS: 'campaigns/GET_SECTIONS_SUCCESS',
  GET_SECTIONS_FAILURE: 'campaigns/GET_SECTIONS_FAILURE',

  GET_SUB_SECTIONS_REQUEST: 'campaigns/GET_SUB_SECTIONS_REQUEST',
  GET_SUB_SECTIONS_SUCCESS: 'campaigns/GET_SUB_SECTIONS_SUCCESS',
  GET_SUB_SECTIONS_FAILURE: 'campaigns/GET_SUB_SECTIONS_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  delete: {
    loading: false,
  },

  channels: {
    data: [],
    loading: true,
  },

  stores: {
    data: [],
    loading: true,
  },

  categories: {
    data: [],
    loading: true,
  },

  productTypes: {
    data: [],
    loading: true,
  },

  sections: {
    data: [],
    loading: true,
  },

  subSections: {
    data: [],
    loading: true,
  },
};

export default function campaigns(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.campaign.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.campaigns.data,
        page: action.payload.campaigns.meta.current_page,
        totals: action.payload.campaigns.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.DELETE_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: true,
        },
      };
    case Types.DELETE_SUCCESS:
    case Types.DELETE_FAILURE:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: false,
        },
      };
    case Types.GET_CHANNELS_REQUEST:
      return {
        ...state,
        channels: {
          ...state.channels,
          loading: true,
        },
      };
    case Types.GET_CHANNELS_SUCCESS:
      return {
        ...state,
        channels: {
          ...state.channels,
          loading: false,
          data: action.payload.channels.data,
        },
      };
    case Types.GET_CHANNELS_FAILURE:
      return {
        ...state,
        channels: {
          ...state.channels,
          loading: false,
        },
      };
    case Types.GET_STORES_REQUEST:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: true,
        },
      };
    case Types.GET_STORES_SUCCESS:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: false,
          data: action.payload.stores.data,
        },
      };
    case Types.GET_STORES_FAILURE:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: false,
        },
      };
    case Types.GET_PRODUCT_TYPES_REQUEST:
      return {
        ...state,
        productTypes: {
          ...state.productTypes,
          loading: true,
        },
      };
    case Types.GET_PRODUCT_TYPES_SUCCESS:
      return {
        ...state,
        productTypes: {
          ...state.productTypes,
          loading: false,
          data: action.payload.productTypes.data,
        },
      };
    case Types.GET_PRODUCT_TYPES_FAILURE:
      return {
        ...state,
        productTypes: {
          ...state.productTypes,
          loading: false,
        },
      };
    case Types.GET_SECTIONS_REQUEST:
      return {
        ...state,
        sections: {
          ...state.sections,
          loading: true,
        },
      };
    case Types.GET_SECTIONS_SUCCESS:
      return {
        ...state,
        sections: {
          ...state.sections,
          loading: false,
          data: action.payload.sections.data,
        },
      };
    case Types.GET_SECTIONS_FAILURE:
      return {
        ...state,
        sections: {
          ...state.sections,
          loading: false,
        },
      };
    case Types.GET_SUB_SECTIONS_REQUEST:
      return {
        ...state,
        subSections: {
          ...state.subSections,
          loading: true,
        },
      };
    case Types.GET_SUB_SECTIONS_SUCCESS:
      return {
        ...state,
        subSections: {
          ...state.subSections,
          loading: false,
          data: action.payload.subSections.data,
        },
      };
    case Types.GET_SUB_SECTIONS_FAILURE:
      return {
        ...state,
        subSections: {
          ...state.subSections,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getCampaignRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getCampaignSuccess: campaign => ({
    type: Types.GET_SUCCESS,
    payload: { campaign },
  }),

  getCampaignFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getCampaignsRequest: (page = 1) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page },
  }),

  getCampaignsSuccess: campaigns => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { campaigns },
  }),

  getCampaignsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createCampaignRequest: data => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createCampaignSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createCampaignFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateCampaignRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateCampaignSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateCampaignFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  deleteCampaignRequest: id => ({
    type: Types.DELETE_REQUEST,
    payload: { id },
  }),

  deleteCampaignSuccess: () => ({
    type: Types.DELETE_SUCCESS,
  }),

  deleteCampaignFailure: () => ({
    type: Types.DELETE_FAILURE,
  }),

  getCampaignChannelsRequest: (query = '') => ({
    type: Types.GET_CHANNELS_REQUEST,
    payload: { query },
  }),

  getCampaignChannelsSuccess: channels => ({
    type: Types.GET_CHANNELS_SUCCESS,
    payload: { channels },
  }),

  getCampaignChannelsFailure: () => ({
    type: Types.GET_CHANNELS_FAILURE,
  }),

  getCampaignStoresRequest: (query = '') => ({
    type: Types.GET_STORES_REQUEST,
    payload: { query },
  }),

  getCampaignStoresSuccess: stores => ({
    type: Types.GET_STORES_SUCCESS,
    payload: { stores },
  }),

  getCampaignStoresFailure: () => ({
    type: Types.GET_STORES_FAILURE,
  }),

  getCampaignProductTypesRequest: (query = '') => ({
    type: Types.GET_PRODUCT_TYPES_REQUEST,
    payload: { query },
  }),

  getCampaignProductTypesSuccess: productTypes => ({
    type: Types.GET_PRODUCT_TYPES_SUCCESS,
    payload: { productTypes },
  }),

  getCampaignProductTypesFailure: () => ({
    type: Types.GET_PRODUCT_TYPES_FAILURE,
  }),

  getCampaignSectionsRequest: (query = '') => ({
    type: Types.GET_SECTIONS_REQUEST,
    payload: { query },
  }),

  getCampaignSectionsSuccess: sections => ({
    type: Types.GET_SECTIONS_SUCCESS,
    payload: { sections },
  }),

  getCampaignSectionsFailure: () => ({
    type: Types.GET_SECTIONS_FAILURE,
  }),

  getCampaignSubSectionsRequest: (query = '', section = null) => ({
    type: Types.GET_SUB_SECTIONS_REQUEST,
    payload: { query, section },
  }),

  getCampaignSubSectionsSuccess: subSections => ({
    type: Types.GET_SUB_SECTIONS_SUCCESS,
    payload: { subSections },
  }),

  getCampaignSubSectionsFailure: () => ({
    type: Types.GET_SUB_SECTIONS_FAILURE,
  }),
};

export const Selectors = {
  channels: createSelector(
    state => state,
    channels => channels.map(channel => ({ value: channel.id, label: channel.attributes.name })),
  ),

  stores: createSelector(
    state => state,
    stores => stores.map(store => ({ value: store.id, label: store.attributes.name })),
  ),

  productTypes: createSelector(
    state => state,
    productTypes => productTypes.map(productType => ({ value: productType.id, label: productType.attributes.name })),
  ),

  sections: createSelector(
    state => state,
    sections => sections.map(section => ({ value: section.id, label: section.attributes.name })),
  ),

  subSections: createSelector(
    state => state,
    subSections => subSections.map(subSection => ({ value: subSection.id, label: subSection.attributes.name })),
  ),
};
